import { render } from "./TestimonialCard.vue?vue&type=template&id=6e9facfb"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__